import { z } from 'zod';

export const companyTypeSchema = z.enum([
  'None',
  'Other',
  'Paying Customer',
  'Partner',
  'Trial',
  'Internal Test',
]);

export type CompanyType = z.infer<typeof companyTypeSchema>;
